<template>
  <div class="c-modal-ca" @click="$emit('close')">
    <div class="c-modal-ca__inner">
      <div class="c-modal-ca__container">
        <button
          class="c-modal-ca__close-button"
          type="button"
          @click="$emit('close')"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="feather feather-x"
          >
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
        <div class="c-modal-ca__content-wrapper" @click.stop>
          <slot name="header" />
          <slot name="content" />
          <slot name="footer" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ModalCABase",
};
</script>

<style lang="stylus" scoped>
.c-modal-ca
  position fixed
  top 0
  left 0
  width 100%
  height 100%
  z-index 999999
  padding 40px
  overflow auto
  background rgba(30,30,30,0.9)

  &__inner
    position relative
    top 0
    left 0
    width 100%
    pointer-events none
    min-height 100%
    display flex
    align-items center

  &__container
    position relative
    width 100%
    z-index 9997
    background #fff
    margin 0 auto
    pointer-events auto
    border-radius 12px
    max-width 530px

  &__content-wrapper
    padding 32px
    text-align center

  &__close-button
    position absolute
    top 8px
    right 8px
    border 0
    background transparent
    cursor pointer
    padding 12px
    border-radius 8px
    display flex
    align-items center
    justify-content center
    &:hover
      background-color rgba(42,42,42,0.06)

  &__close-button > svg
    width 22px
    height 22px

  @media (max-width 575px)
    padding 16px 12px
    &__content-wrapper
      padding 24px 20px
  @media (max-width 320px)
      padding 20px 16px
</style>
